import { isLocalStorageAvailable } from '@lib/analytics/utils'
import * as Sentry from '@sentry/nextjs'
import { isPrd } from '@shared/util/env'

import { injectOneLinkScriptDev } from './scripts/onelink-dev'

/**
 * Initialize OneLink Smart Script for dev.step.com and stg.step.com
 *
 * The actual script is in ./scripts/onelink-dev.ts for easy updates.
 */
export const initOneLinkSmartScriptDev = (): void => {
    if (typeof window === 'undefined') {
        return
    }

    // Skip if already initialized
    if (window.AF_SMART_SCRIPT) {
        return
    }

    // The vendored OneLink script accesses localStorage directly.
    // In some environments (e.g. Chrome Mobile WebView), localStorage
    // is null, causing a TypeError. Skip initialization gracefully.
    if (!isLocalStorageAvailable()) {
        return
    }

    try {
        injectOneLinkScriptDev()

        if (!isPrd()) {
            console.debug('OneLink Smart Script (dev) initialized')
        }
    } catch (error) {
        Sentry.captureException(error, {
            tags: {
                errorType: 'onelink_init_failed',
                analytics: 'appsflyer',
                environment: 'dev',
            },
        })
        if (!isPrd()) {
            console.error(
                'Failed to initialize OneLink Smart Script (dev):',
                error,
            )
        }
    }
}
